
import React from 'react';
import Layout from '@/components/Layout';

const AboutPage: React.FC = () => {
  return (
    <Layout>
      <div className="container py-10">
        <h1 className="text-3xl font-bold">About Us</h1>
        <p className="mt-4">Learn more about our organization.</p>
      </div>
    </Layout>
  );
};

export default AboutPage;
